import { render } from "./policy-deploy.vue?vue&type=template&id=1a9af76a&scoped=true&ts=true"
import script from "./policy-deploy.vue?vue&type=script&lang=ts"
export * from "./policy-deploy.vue?vue&type=script&lang=ts"

import "./policy-deploy.vue?vue&type=style&index=0&id=1a9af76a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9af76a"]])

export default __exports__